import { graphql } from '@/gql';
import type { FetchNumberOfRidesTakenPerPartnerQuery, FetchNumberOfRidesTakenPerPartnerQueryVariables } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';

export type FetchNumberOfRidesTakenPerPartnerInput = FetchNumberOfRidesTakenPerPartnerQueryVariables;

export type FetchNumberOfRidesTakenPerPartnerOutput = FetchNumberOfRidesTakenPerPartnerQuery['getNumberOfRidesPerPartner'];

export const fetchNumberOfRidesTakenPerPartner = async ({
  endDate,
  pagination,
  partnerName,
  startDate,
  status,
}: FetchNumberOfRidesTakenPerPartnerInput): Promise<FetchNumberOfRidesTakenPerPartnerOutput> => {
  const response = await queryExecute({
    query: graphql(`
      query FetchNumberOfRidesTakenPerPartner(
        $partnerName: String
        $status: String
        $startDate: String
        $endDate: String
        $pagination: PaginationInputType
      ) {
        getNumberOfRidesPerPartner(
          partnerName: $partnerName
          status: $status
          startDate: $startDate
          endDate: $endDate
          pagination: $pagination
        ) {
          count
          rows {
            numberOfRides
            partnerName
            totalPartnerSpend
          }
        }
      }
    `),
    variables: {
      partnerName,
      status,
      startDate,
      endDate,
      pagination,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data.getNumberOfRidesPerPartner;
};
